/**
 * Generates a random 64-byte hexadecimal string with "0x" prefix
 * This is used for the salt parameter in timelockController.schedule and execute functions
 * The salt guarantees uniqueness of the OperationID which must be identical for execute to work based on a schedule() operationID
 * 
 * @returns {string} A 64-byte hexadecimal string with "0x" prefix (e.g., "0x43a21bb742b6f77f91877ce0a816dccd658f995ddd22eddd1e7afdad28a27381")
 */
export const generateRandomSalt = (): string => {
    // Create a new array of 32 random bytes (which will become 64 hex characters)
    const randomBytes = new Uint8Array(32);

    // Fill the array with cryptographically strong random values
    window.crypto.getRandomValues(randomBytes);

    // Convert to hexadecimal string
    let hexString = '';
    for (let i = 0; i < randomBytes.length; i++) {
        // Convert each byte to a 2-digit hex string and append to result
        const hex = randomBytes[i].toString(16).padStart(2, '0');
        hexString += hex;
    }

    // Add "0x" prefix
    return '0x' + hexString;
};
